import { ArrowUpRight } from "lucide-react";
import { t, tf, getLang } from "@/lib/i18n";

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 3600) return tf("{n}m ago", { n: Math.floor(s / 60) || 1 });
  if (s < 86400) return tf("{n}h ago", { n: Math.floor(s / 3600) });
  if (s < 86400 * 7) return tf("{n}d ago", { n: Math.floor(s / 86400) });
  return new Date(iso).toLocaleDateString(getLang() === "hi" ? "hi-IN" : "en-IN", { day: "numeric", month: "short", year: "numeric" });
}

const TOPIC_TONE = {
  penalties: "bg-[#FBE9E3] text-[#9A3B22]", civic: "bg-[#E7EEF9] text-[#264B86]",
  plastic: "bg-[var(--marigold-soft)] text-[#7A4B07]", climate: "bg-[#E3F2F1] text-[#1D5F5A]",
  waste_workers: "bg-[var(--stone)] text-[#7B3A26]", policy: "bg-[#EEE8F7] text-[#4D3780]",
};

export default function NewsCard({ item, index }) {
  return (
    <a href={item.link} target="_blank" rel="noreferrer noopener" data-testid={`news-card-${index}`}
      className="group block bg-white rounded-2xl border border-[rgba(20,40,26,.08)] p-5 sm:p-6 card-lift">
      <div className="flex items-center gap-2 flex-wrap text-xs">
        <span className={`px-2.5 py-1 rounded-full font-semibold ${TOPIC_TONE[item.topic] || "bg-[var(--leaf-soft)] text-[var(--leaf-dark)]"}`}>{t(item.topic_label)}</span>
        <span className="text-[var(--ink-soft)] font-medium">{item.publisher}</span>
        <span className="text-[var(--ink-soft)]">·</span>
        <time className="text-[var(--ink-soft)]" dateTime={item.published_iso} title={item.published_iso ? new Date(item.published_iso).toLocaleString("en-IN") : ""}>{timeAgo(item.published_iso)}</time>
      </div>
      <h3 className="mt-3 font-display text-lg sm:text-xl font-semibold leading-snug group-hover:text-[var(--leaf-dark)] transition-colors">{t(item.title)}</h3>
      <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[var(--leaf-dark)]">{t("Read on")} {item.publisher} <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
    </a>
  );
}
